import { css } from '@emotion/css';

const columnGap = 1.2; // column gap between meta fields

export const rootContainerStyles = css`
  grid-template-columns: 22rem 1fr calc(50% - ${columnGap / 2}rem);

  column-gap: ${columnGap}rem;

  .meta-field:nth-child(odd) {
    grid-column: 1/3;
  }
  .meta-field:nth-child(even) {
    grid-column: 3/4;
  }
  .meta-field:nth-child(2) {
    grid-column: 2/4;
  }
`;

export const picklistStyles = css`
  width: 22rem;

  .MuiOutlinedInput-root {
    flex-wrap: nowrap;
  }

  .MuiOutlinedInput-input {
    min-width: unset;
  }
`;
